
import Header from '@/components/taxi/core/Header';
import Footer from '@/components/taxi/core/Footer';
export default {
    components:{
        Header,
        Footer
    },
    head() {
      return {
        meta: [
        { hid: 'og:url',
        property: 'og:url',
        content: this.$config.siteUrl + this.$route.path
      },
      ],
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: 'https://www.goa.app' + this.$route.path
        }
      ],
        bodyAttrs: {
          class: 'pb-0'
        }
      }
    },
}
